<template>
  <b-tabs
    
    content-class="col-12  mt-1 mt-md-0"
    pills
    nav-wrapper-class=" col-12"
    nav-class="nav-left d-flex"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t("general") }}</span>
      </template>

      <account-setting-general
        v-if="userData"
        :general-data="userData"
      />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t("changePassword") }}</span>
      </template>
      
      <account-setting-password />
    </b-tab>
   
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'

import AccountSettingSocial from './AccountSettingSocial.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,

    AccountSettingSocial,
    AccountSettingNotification,
  },
  data() {
    return {
      options: {},
       userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeCreate() {
    
    // this.$http.get('/account-setting/data').then(res => { this.options = res.data })
  },
}
</script>
